// mutation
export const SET_USER_INFO = 'setUserInfo'
export const SET_PAG_INS = 'setPagIns'
export const SET_CURR_POINT = 'setCurrPoint'
export const SET_CAN_AUTO_PLAY = 'setCanAutoPlay'
export const SET_AUDIO_LOADED = 'setAudioLoaded'
// actions
export const ACT_USER_INFO = 'fetchUserInfo'
export const ACTION_PRE = 'actionPre'
